// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reply-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  margin: 0 16px 0;
  border-radius: 12px 12px 0 0;
  background: linear-gradient(135deg, rgba(153, 27, 27, 0.1), rgba(153, 27, 27, 0.06));
  border: 1px solid rgba(153, 27, 27, 0.25);
  border-bottom: none;
  font-size: 13px;
  backdrop-filter: blur(8px);
  position: relative;
  overflow: hidden;
}

.reply-bar::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: var(--brand-primary);
}

.reply-bar-icon {
  color: var(--brand-light);
  flex-shrink: 0;
  opacity: 0.8;
}

.reply-bar-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
  overflow: hidden;
}

.reply-bar-title {
  font-size: 12px;
  font-weight: 700;
  color: var(--brand-light);
  flex-shrink: 0;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.reply-bar-author {
  font-size: 13px;
  font-weight: 700;
  color: var(--text-primary);
  flex-shrink: 0;
}

.reply-bar-author::before {
  content: '@';
  opacity: 0.6;
}

.reply-bar-preview {
  font-size: 13px;
  color: var(--text-muted);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  flex: 1;
  min-width: 0;
}

.reply-bar-preview::before {
  content: '— ';
  opacity: 0.4;
}

.reply-bar-close {
  border: none;
  background: transparent;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
  padding: 4px;
  flex-shrink: 0;
  transition: all var(--transition-fast);
}

.reply-bar-close:hover {
  background-color: rgba(239, 68, 68, 0.15);
  color: #ef4444;
}
`, "",{"version":3,"sources":["webpack://./src/components/Reply/Reply.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,oFAAoF;EACpF,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB","sourcesContent":[".reply-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 16px;\n  margin: 0 16px 0;\n  border-radius: 12px 12px 0 0;\n  background: linear-gradient(135deg, rgba(153, 27, 27, 0.1), rgba(153, 27, 27, 0.06));\n  border: 1px solid rgba(153, 27, 27, 0.25);\n  border-bottom: none;\n  font-size: 13px;\n  backdrop-filter: blur(8px);\n  position: relative;\n  overflow: hidden;\n}\n\n.reply-bar::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background: var(--brand-primary);\n}\n\n.reply-bar-icon {\n  color: var(--brand-light);\n  flex-shrink: 0;\n  opacity: 0.8;\n}\n\n.reply-bar-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  flex: 1;\n  overflow: hidden;\n}\n\n.reply-bar-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--brand-light);\n  flex-shrink: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.reply-bar-author {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--text-primary);\n  flex-shrink: 0;\n}\n\n.reply-bar-author::before {\n  content: '@';\n  opacity: 0.6;\n}\n\n.reply-bar-preview {\n  font-size: 13px;\n  color: var(--text-muted);\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  flex: 1;\n  min-width: 0;\n}\n\n.reply-bar-preview::before {\n  content: '— ';\n  opacity: 0.4;\n}\n\n.reply-bar-close {\n  border: none;\n  background: transparent;\n  color: var(--text-muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  cursor: pointer;\n  padding: 4px;\n  flex-shrink: 0;\n  transition: all var(--transition-fast);\n}\n\n.reply-bar-close:hover {\n  background-color: rgba(239, 68, 68, 0.15);\n  color: #ef4444;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
